import React, { Component } from "react";
import { http, baseURL } from "../../misc/http";
import Navigation from "./BlogArticleNav";
import BlogList from "./BlogArticleList";
export default class BlogArticle extends Component {
  state = {
    listCategory: [],
    listBlog: [],
    activeTab: "all",
    page: 1,
    limit: 12,
    onLoad: false,
  };

  componentDidMount = async () => {
    await this.handleGetAllCategory();
    this.handleGetAll("&page=1&limit=1");
  };

  handleGetAll = async () => {
    const { page, limit, activeTab } = this.state;
    await this.setState({ onLoad: true });
    let additionalParam = "";
    if (activeTab !== "all") additionalParam = "category=" + activeTab;
    let params = {
      method: "GET",
      path:
        "blog?status=publish&page=" +
        page +
        "&limit=" +
        limit +
        "&" +
        additionalParam,
      showMessage: false,
    };
    let { data } = await http(params);
    if (data.status === true && data.code === 200) {
      let { listBlog } = this.state;
      listBlog = data.data;
      this.setState({
        listBlog,
      });
    } else this.setState({ listBlog: [] });
    await this.setState({ onLoad: false });
  };

  handleGetAllCategory = async () => {
    await this.setState({ onLoad: true });
    let params = {
      method: "GET",
      path: "blog/category/findAll",
      showMessage: false,
    };
    let { data } = await http(params);
    if (data.status === true && data.code === 200) {
      let { listCategory } = this.state;
      listCategory = data.data;
      this.setState({
        listCategory,
      });
    } else this.setState({ listCategory: [] });
    await this.setState({ onLoad: false });
  };

  handleClickTab = async (activeTab) => {
    await this.setState({ activeTab, page: 1, listBlog: [] });
    this.handleGetAll();
  };

  handleNavigation = async (nav) => {
    let page = this.state.page;
    if (nav === "next") page += 1;
    else page -= 1;
    await this.setState({ page });
    this.handleGetAll();
  };

  render() {
    return (
      <div class="row">
        <Navigation
          handleClickTab={this.handleClickTab}
          activeTab={this.state.activeTab}
          listCategory={this.state.listCategory}
          onLoad={this.state.onLoad}
        />
        <BlogList
          listBlog={this.state.listBlog}
          baseURL={baseURL}
          validPrev={this.state.page > 1 ? true : false}
          validNext={
            this.state.listBlog.length === this.state.limit ? true : false
          }
          handleNavigation={this.handleNavigation}
          onLoad={this.state.onLoad}
        />
      </div>
    );
  }
}
